<script>
import ReportingApi from "@/services/reporting-api";

export default {
  props: {
    campaignId: { type: Number, default: null },
    range: Object
  },

  data() {
    return {
      chartOptions: {},
      pageChart: 1,
      pageSize: 10,
      apexChartsKey: 0,
      
      // Store the full dataset from API here
      allData: {
        date: [],
        entryCount: [],
        uniqueScans: []
      },
    };
  },

  computed: {
    totalPages() {
      return Math.ceil(this.allData.date.length / this.pageSize);
    }
  },

  mounted() {
    this.getScanPerDay();
  },

  watch: {
    pageSize() {
      this.pageChart = 1;
      this.renderAreaChart();
    },

    campaignId() {
      this.getScanPerDay();
    },

    range: {
      handler(newVal) {
        if (newVal?.startDate && newVal?.endDate) {
          this.getScanPerDay();
        }
      },
      deep: true,
      immediate: false
    }
  },

  methods: {
    nextPage() {
      if (this.pageChart < this.totalPages) {
        this.pageChart++;
        this.renderAreaChart();
      }
    },

    previousPage() {
      if (this.pageChart > 1) {
        this.pageChart--;
        this.renderAreaChart();
      }
    },

    renderAreaChart() {
      const start = (this.pageChart - 1) * this.pageSize;
      const end = start + parseInt(this.pageSize);

      const slicedDate = this.allData.date.slice(start, end);
      const slicedEntry = this.allData.entryCount.slice(start, end);
      const slicedUnique = this.allData.uniqueScans.slice(start, end);

      this.chartOptions = {
        series: [
          { name: "QR codes scannés", data: slicedEntry },
          { name: "Scans uniques", data: slicedUnique },
        ],
        colors: ["#1d3266", "#D4AF37"],
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            opacityFrom: 0.8,
            opacityTo: 0.3,
          },
        },
        chart: {
          type: "area",
          toolbar: { show: false },
          height: "350",
          width: "100%",
        },
        dataLabels: { enabled: false },
        stroke: { curve: "smooth", width: 2 },
        
        xaxis: {
          categories: slicedDate,
          tickAmount: slicedDate.length,
          labels: {
            show: true,
            rotate: -45,
            rotateAlways: true,
            style: {
              fontSize: '12px',
              fontWeight: 'bold',
            },
          },
          axisBorder: { show: true },
        },

        yaxis: { show: false },
        tooltip: { enabled: true },
      };

      this.apexChartsKey++;
    },

    getScanPerDay() {
      const params = {
        campaignId: this.campaignId,
        start: this.range?.startDate,
        end: this.range?.endDate
      };

      ReportingApi.getScanPerDay(params)
        .then(res => {
          this.allData = res || {
            date: [],
            entryCount: [],
            uniqueScans: []
          };
          this.renderAreaChart();
        })
        .catch(err => {
          console.error("Error fetching data:", err);
        });
    },
  },
};
</script>

<template>
  <div class="h-100">
    <div class="row">
      <div class="col-md-6 col-12 text-uppercase text-dark font-weight-bold font-size-14 mb-4">
        {{ $t("campaign.card.scanByDay") }}
      </div>

      <div class="col-md-6 col-12 d-flex justify-content-end align-items-center">
        <div>
          <!-- Left Arrow: previousPage -->
          <img
            class="mr-2"
            width="17"
            src="@/assets/icons/left-2.svg"
            @click="previousPage"
            :style="{
              opacity: pageChart === 1 ? 0.5 : 1,
              pointerEvents: pageChart === 1 ? 'none' : 'auto',
              cursor: pageChart === 1 ? 'default' : 'pointer'
            }"
          />
          <span class="mr-2">page {{ pageChart }} / {{ totalPages || 1 }}</span>
          
          <!-- Right Arrow: nextPage -->
          <img
            width="17"
            src="@/assets/icons/right-2.svg"
            @click="nextPage"
            :style="{
              opacity: pageChart >= totalPages ? 0.5 : 1,
              pointerEvents: pageChart >= totalPages ? 'none' : 'auto',
              cursor: pageChart >= totalPages ? 'default' : 'pointer'
            }"
          />
        </div>

        <div>
          <select class="custom-select custom-select-sm ml-2" v-model="pageSize">
            <option value="10">10</option>
            <option value="30">30</option>
          </select>
        </div>
      </div>
    </div>

    <apexchart
      ref="apexchart"
      v-if="allData.date.length > 0"
      :key="apexChartsKey"
      type="area"
      height="350"
      :options="chartOptions"
      :series="chartOptions.series"
    />

    <div
      v-else
      class="d-flex justify-content-center align-items-center text-info h-100"
      style="min-height: 340px"
    >
      Pas de collecte de données
    </div>
  </div>
</template>

<style>
.apex-charts text {
  font-weight: bold !important;
  fill: #121212 !important;
}
.apexcharts-yaxis text,
.apexcharts-xaxis text {
  font-weight: bold !important;
  fill: #121212 !important;
}
</style>